import { cn } from '@/lib/utils';
import { useState } from 'react';
import { Sheet, SheetContent, SheetHeader, SheetTrigger } from '@/components/ui/sheet';
import { Checkbox } from '@/components/ui/checkbox';
import { useTheme } from '@/components/ThemeProvider';
import { ArrowDown } from '@/widget/Icon';
import TokenAvatar from '@/widget/TokenAvatar';
import { t } from 'i18next';
import { useTradeStore } from '@/page/trade/store';
import { useAppStore } from '@/store';

type SellType = 'percent' | 'count';

interface IProps {
  sellType: SellType;
  onChangeOrderType: (type: SellType) => void;
}

export default (props: IProps) => {
  const { sellType, onChangeOrderType } = props;
  const { fwClass } = useAppStore();
  const { tokenInfo } = useTradeStore();
  const { theme } = useTheme();

  const [open, setOpen] = useState(false);

  const onCheck = (type: SellType) => {
    onChangeOrderType(type);
    setOpen(false);
  };

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <div className="absolute flex items-center right-0 top-[50%] translate-y-[-50%]">
          {sellType == 'percent' ? '%' : <TokenAvatar className="size-[18px]" logo={tokenInfo?.logo || ''} address={tokenInfo?.address || ''} />}
          <ArrowDown theme={theme} className="size-[24px]" />
        </div>
      </SheetTrigger>
      <SheetContent side="bottom" hideCloseIcon className="h-[145px] p-[16px] border-t-[1px] border-t-borderColor">
        <SheetHeader hidden></SheetHeader>
        <div className="flex flex-col gap-y-[20px]">
          <div className="flex justify-between" onClick={() => onCheck('percent')}>
            <span className={cn('text-[16px]', fwClass)}>{t('Trade.percent')}</span>
            <Checkbox className="rounded-full size-[20px]" checked={sellType == 'percent'} />
          </div>
          <div className="flex justify-between" onClick={() => onCheck('count')}>
            <span className={cn('text-[16px]', fwClass)}>{t('Trade.quantity')}</span>
            <Checkbox className="rounded-full size-[20px]" checked={sellType == 'count'} />
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
};
